import useSWR, { SWRConfiguration } from "swr";
import useSWRMutation from "swr/mutation";

import { CheckResetTokenResponse } from "@/services/api/auth/types";

export const useCheckResetToken = (token: string | undefined) => {
  return useSWR<CheckResetTokenResponse>(token ? `/api/auth/reset/check/${token}` : null, {
    revalidateOnFocus: false,
    revalidateIfStale: false,
    revalidateOnReconnect: false,
    shouldRetryOnError: false,
  });
};

export const useConfirmToken = (token: string | string[] | undefined, options: SWRConfiguration) => {
  return useSWR(token ? `/api/auth/confirm/${token}` : null, {
    revalidateOnFocus: false,
    revalidateIfStale: false,
    revalidateOnReconnect: false,
    shouldRetryOnError: false,
    ...options,
  });
};

// New hook for check session
export const useCheckSession = () => {
  return useSWRMutation("/api/auth/check", async url => {
    const response = await fetch(url, {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error("Not authenticated");
    }
    return response.json();
  });
};
